@import '../../theme/global.scss';

:host {
  color: $gray-800;
  display: flex;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  @include set-font;
  @include box-sizing;
  @include button-reset;

  @media (min-width: map-get($breakpoints, 'md')) {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  a {
    color: $gray-800;
    margin: 0;
    padding: 0;
    text-decoration: none;
  }

  li {
    display: flex;
    width: 100%;

    .wrapper {
      align-items: center;
      cursor: pointer;
      display: flex;
      flex-flow: row;
      justify-content: flex-start;
      list-style-type: none;
      margin: 0;
      padding: 0.563rem 1rem;
      text-indent: 0;
      width: 100%;

      snap-icon {
        margin-right: 0.25rem;
      }

      snap-indicator {
        --indicator-background-color: #{$gray-600};
        --indicator-text-color: #{$base-light};
        margin-left: 0.25rem;
      }
    }
  }
}

:host(.active) {
  background-color: $blue-100;
}

:host(:hover) {
  background-color: $blue-200;
}

:host(.divider) {
  border-bottom: 1px solid $gray-200;
}
